module.exports = __webpack_public_path__ + "static/media/0100_Medium.82130a44.jpg";